import { patientQueryOptions } from '@app/icare/entities/patient/queries/patientQueryOptions'
import { patientTherapyQueries } from '@app/icare/entities/patient/queries/patientTherapyQueries'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { mapPatientTherapyToTherapyStatus } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { TherapyTable } from './-components/TherapyTable'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/bedarfsermittlungen/$therapy')({
  component: RouteComponent,
  params: entityParams({ id: PatientId }),
})

function RouteComponent() {
  const params = Route.useParams()
  const { data: patient } = useSuspenseQuery(patientQueryOptions(params.id))
  const { data: therapies = [] } = useSuspenseQuery(patientTherapyQueries.forIndex(params.id))

  const found = therapies.find(th => th.id === params.therapy)
  const therapy = found ? { ...found, status: mapPatientTherapyToTherapyStatus(found, patient?.deceased) } : null

  if (!therapy) return null

  return <TherapyTable patientId={params.id} therapy={therapy} />
}
